import { gql } from '@apollo/client';
import { assetChildrenDetailsFragment } from './zevAssetsByProperty.query';

export const utilizationUnitAssetQuery = gql`
  query UtilizationUnitAsset($utilizationUnitAssetId: ID!) {
    asset(assetId: $utilizationUnitAssetId) {
      id
      name
      type {
        id
        name
        outgoingRelations {
          id
          target {
            id
            name
          }
        }
      }
      attributeValues {
        value
        attributeType {
          id
        }
      }
    }
  }
`;

export const childrenAssetsByUtilizationUnitQuery = gql`
  query ChildrenAssetsByUtilizationUnit(
    $constraints: [AssetSearchConstraint]
    $childAssetSearchConstraints: [ChildAssetSearchConstraint]
    $relationTypeId: ID!
    $pagination: AssetPagination
  ) {
    assets(constraints: $constraints, pagination: $pagination) {
      ... on AssetsResult {
        totalNumberOfAssets
        assetsGroupedByAssetType {
          numberOfAssets
          assetType {
            id
            name
          }
          assets {
            id
            name
            type {
              id
              name
              outgoingRelations {
                id
                target {
                  id
                  name
                }
              }
            }
            attributeValues {
              id
              value
              attributeType {
                id
                name
                orderIndex
              }
            }
            children(constraints: $childAssetSearchConstraints, relationTypeId: $relationTypeId) {
              ... on AssetsResult {
                ...AssetChildrenDetails
              }
            }
          }
        }
      }
    }
  }

  ${assetChildrenDetailsFragment}
`;
